import request from '@/http/http'
const PREFIX = 'api/deer/system';
//用户基础字段
export function getUserSettings() {
  return request({
    url: PREFIX + '/user-settings',
  })
}

export function updateUserSettings(key, data) {
  return request({
    url: PREFIX + "/update-user-settings" + key,
    method: 'put',
    data
  })
}
export function updateOuSettings(key, data) {
  return request({
    url: PREFIX + "/update-ou-settings" + key,
    method: 'put',
    data
  })
}
//机构基础字段
export function getOuSettings() {
  return request({
    url: PREFIX + "/ou-settings"
  })
}
//密码配置规则
export function getIdentitySettings() {
  return request({
    url: PREFIX + "/identity-settings"
  })
}
export function getPublicIdentitySettings() {
  return request({
    url: PREFIX + "/public/identity-settings"
  })
}
export function updateIdentitySettings(data,query) {
  return request({
    url: PREFIX + "/update-identity-settings"+query,
    method: 'put',
    data
  })
}
// 短信配置
export function getSmsSettings() {
  return request({
    url: PREFIX + "/sms-settings"
  })
}
export function updateSmsSettings(data,query) {
  return request({
    url: PREFIX + "/update-sms-settings"+query,
    method: 'put',
    data
  })
}

// 岗位异动规则
export function getJobchangeSettings() {
  return request({
    url: PREFIX + '/job-change-settings',
  })
}

//管理工号配置规则
export function updateCompanySettings(data,query) {
  return request({
    url: PREFIX + "/update-company-settings"+query ,
    method: 'put',
    data
  })
}
//管理工号资料上传
export function updateUploadFile(formData) {
  return request({
    url: PREFIX + "/upload-file" ,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
// 固定字段
export function allEnumMetadata() {
  return request({
    url: PREFIX + "/all-enum-metadata" ,
    method: "get"
  })
}

//分销商配置规则
export function getCompanySettings() {
  return request({
    url: PREFIX + "/company-settings"
  })
}
//分销商门店配置规则
export function getCompanyStoreSettings() {
  return request({
    url: PREFIX + "/company-store-settings"
  })
}
//客源设置
export function customerSettings() {
  return request({
    url: PREFIX + "/customer-settings" ,
    method: "get"
  })
}

export function updateCustomerSettings(query,data) {
  return request({
    url: PREFIX + "/update-customer-settings"+query ,
    method: 'put',
    data
  })
}

//楼盘配置
export function estateSettings() {
  return request({
    url: PREFIX + "/estate-settings" ,
    method: "get"
  })
}

export function updateEstateSettings(query,data) {
  return request({
    url: PREFIX + "/update-estate-settings"+query ,
    method: 'put',
    data
  })
}
// 微信配置
export function getWeixinSettings() {
  return request({
    url: PREFIX + "/weixin-settings"
  })
}
export function updateWeixinSettings(data,query) {
  return request({
    url: PREFIX + "/update-weixin-settings"+query,
    method: 'put',
    data
  })
}

//地区配置
export function getAreaSettings() {
  return request({
    url: PREFIX + "/area-settings"
  })
}

export function updateAreaSettings(query,data) {
  return request({
    url: PREFIX + "/update-area-settings"+query,
    method: 'put',
    data
  })
}

//资讯基础字段
export function getInformationSettings() {
  return request({
    url: PREFIX + '/news-settings',
  })
}
export function updateInformationSettings(key, data) {
  return request({
    url: PREFIX + "/update-news-settings" + key,
    method: 'put',
    data
  })
}
//广告基础字段
export function getAdsSettings() {
  return request({
    url: PREFIX + '/ads-settings',
  })
}
export function updateAdsSettings(key, data) {
  return request({
    url: PREFIX + "/update-ads-settings" + key,
    method: 'put',
    data
  })
}

//基础字段
export function getCooperationSettings() {
  return request({
    url: PREFIX + '/cooperation-settings',
  })
}
export function updateCooperationSettings(key, data) {
  return request({
    url: PREFIX + "/update-cooperation-settings" + key,
    method: 'put',
    data
  })
}

//交易基础字段

export function getTransactionSettings(query) {
  return request({
    url: PREFIX + '/transaction-settings',
    params: query
  })
}
export function updateTransactionSettings(key, data) {
  return request({
    url: PREFIX + "/update-transaction-settings" + key,
    method: 'put',
    data
  })
}

//交易设置
export function updateTransactionPaymentMaterialSettings(key, data) {
  return request({
    url: PREFIX + "/update-transaction-payment-material-settings" + key,
    method: 'put',
    data
  })
}
//更新交易结佣方式
export function updateTransactionCommissionWaySettings(key, data) {
  return request({
    url: PREFIX + "/update-transaction-commission-way-settings" + key,
    method: 'put',
    data
  })
}

//租户设置
export function getTenantSettings() {
  return request({
    url: PREFIX + "/tenant-settings"
  })
}
export function updateTenantSettings(key, data) {
  return request({
    url: PREFIX + "/update-tenant-settings" + key,
    method: 'put',
    data
  })
}